export const ROUTES = {
    HOME: '/',
    CASINOS: '/casinos',
    CASINO_DETAILS: '/casinos/:id',
    NOT_FOUND: '*'
} as const;
